const API_URL = process.env.REACT_APP_BACKEND_URL;

export function getAuthHeaders() {
  const user = JSON.parse(localStorage.getItem('currentUser') || 'null');
  return {
    'Content-Type': 'application/json',
    ...(user?.id ? { 'X-User-Id': user.id } : {}),
  };
}

export async function apiFetch(path, options = {}) {
  const user = JSON.parse(localStorage.getItem('currentUser') || 'null');
  const headers = {
    ...(user?.id ? { 'X-User-Id': user.id } : {}),
    ...options.headers,
  };

  // Don't set Content-Type for FormData (browser sets it with boundary)
  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = headers['Content-Type'] || 'application/json';
  }

  return fetch(`${API_URL}${path}`, {
    ...options,
    headers,
  });
}
